import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Hook to get the current responsive breakpoint
 * @returns Current breakpoint string: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
 */
export const useCurrentBreakpoint = (): 'xs' | 'sm' | 'md' | 'lg' | 'xl' => {
  const theme = useTheme();
  // const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isMd) return 'md';
  if (isSm) return 'sm';
  return 'xs';
};

